class Note < ApplicationRecord
  validates :title, presence: true
  validates :body, presence: true

  # Real-time updates via JsonStreamProvider
  after_create_commit -> { broadcast_json_to "notes", "note_created" }
  after_update_commit -> { broadcast_json_to "notes", "note_updated" }
  after_destroy_commit -> { broadcast_json_to "notes", "note_destroyed" }

  scope :recent, -> { order(updated_at: :desc) }
  scope :search, ->(query) { where("title LIKE ?", "%#{query}%") if query.present? }
end
